module.exports = __webpack_public_path__ + "img/upload.21c6fbad.svg";